import React, { useCallback } from 'react';
import { Target } from 'lucide-react';
import SectionShell from './SectionShell';

/**
 * ScopeSection — three required narrative fields.
 * The "Stop and Rebrief If" list is critical: it defines the conditions
 * that MUST trigger a rebrief before continuing.
 */
export default function ScopeSection({ draft, onChange }) {
  const scope = draft.scope || {};
  const set = useCallback((key, value) => {
    onChange({ scope: { ...scope, [key]: value } });
  }, [scope, onChange]);

  return (
    <SectionShell
      icon={Target}
      title="Scope"
      subtitle="Define exactly what IS being worked on, what is NOT, and the conditions that must trigger a rebrief."
      color="#67e8f9"
      badge="Required"
      testId="jbv2-section-scope"
    >
      <label className="jbv2-field">
        <span className="jbv2-field-label">In scope</span>
        <textarea
          className="jbv2-field-textarea"
          value={scope.in_scope || ''}
          placeholder="Bullet list — what the crew IS doing today. Example: switch out breaker 3-4, install new relay panel."
          onChange={(e) => set('in_scope', e.target.value)}
          data-testid="jbv2-scope-in"
        />
      </label>
      <label className="jbv2-field">
        <span className="jbv2-field-label">Out of scope</span>
        <textarea
          className="jbv2-field-textarea"
          value={scope.out_of_scope || ''}
          placeholder="What is NOT being touched. Example: adjacent bay B remains energized; do NOT open its door."
          onChange={(e) => set('out_of_scope', e.target.value)}
          data-testid="jbv2-scope-out"
        />
      </label>
      <label className="jbv2-field">
        <span className="jbv2-field-label">Stop &amp; rebrief if…</span>
        <textarea
          className="jbv2-field-textarea"
          value={scope.stop_and_rebrief_if || ''}
          placeholder="Conditions that require a rebrief. Example: weather changes, additional equipment de-energized, crew composition changes, unexpected voltage encountered."
          onChange={(e) => set('stop_and_rebrief_if', e.target.value)}
          data-testid="jbv2-scope-stop"
        />
        <span className="jbv2-field-help">
          Stewie will remind you: any of these triggers = a rebrief (immutable snapshot saved automatically).
        </span>
      </label>
    </SectionShell>
  );
}
